export default __webpack_public_path__ + "static/media/1965.c16f1d9f.jpg";